import type { FC } from "react";
import React, { createContext, useContext, useMemo } from "react";

import { useGetIsMeta } from "~/clientState/hooks/useGetIsMeta";

interface SessionScopeProviderProps {
  isMeta?: boolean;
}

interface SessionScopeProviderContextType {
  isMeta?: boolean;
}

const SessionScopeProviderContext =
  createContext<SessionScopeProviderContextType>({});

export const useIsMeta = (): boolean => {
  const { isMeta } = useContext(SessionScopeProviderContext);
  // TODO(APES-1686): Remove this when the provider is used in frontend-shell
  const isMetaFromOdigeoVariable = useGetIsMeta();

  return isMeta ?? isMetaFromOdigeoVariable;
};

const SessionScopeProvider: FC<SessionScopeProviderProps> = ({
  isMeta,
  children,
}) => {
  const value = useMemo(
    () => ({
      isMeta,
    }),
    [isMeta],
  );

  return (
    <SessionScopeProviderContext.Provider value={value}>
      {children}
    </SessionScopeProviderContext.Provider>
  );
};

export default SessionScopeProvider;
